<template>
  <CardTemplate
    class="card"
    :routeObj="{ name: 'page', params: { page: url } }"
    :onmouseenter="play"
    :onmouseleave="pause"
  >
    <div :class="['card-anim', { loaded }]">
      <canvas ref="riveCanvas" width="868" height="800"></canvas>
    </div>
    <p class="card-title">{{ title }}</p>
  </CardTemplate>
</template>

<script setup>
// import ButtonPrimary from "./ButtonPrimary.vue";
import CardTemplate from "./CardTemplate.vue";
import { ref, onMounted, inject, computed } from "vue";
import { useI18n } from "vue-i18n";

import { Rive, RuntimeLoader } from "@rive-app/canvas";
// import riveWASMResource from "@rive-app/canvas/rive.wasm";

// RuntimeLoader.setWasmUrl(riveWASMResource);

const props = defineProps({
  title: String,
  url: String,
  cta: String,
});

const i18n = useI18n();
const { tm } = useI18n();
const baseUrl = inject("$baseUrl");
const riveCanvas = ref(null);
const loaded = ref(false);
const key = computed(() =>
  i18n.locale.value == "en" ? tm("translation")[props.url] : props.url
);

const touchDevice = inject("$touchDevice");

let rive;

onMounted(() => {
  if (key.value) {
    let artboard = key.value[0].toUpperCase() + key.value.slice(1);

    rive = new Rive({
      src: `${baseUrl}anims/${key.value}.riv`,
      canvas: riveCanvas.value,
      artboard: artboard,
      autoplay: touchDevice,
      onLoad: () => {
        rive.resizeDrawingSurfaceToCanvas();
        loaded.value = true;
      },
    });
  }
});

const play = () => {
  rive.play();
};
const pause = () => {
  rive.pause();
};
</script>

<style lang="scss" scoped>
.card {
  --cta-right: #{toRem(20)};
  --cta-bottom: #{toRem(16)};

  width: toRem(240);
  aspect-ratio: 1;
  border-radius: 24px;
  border: 1px solid var(--color-white);
  position: relative;
  overflow: hidden;

  &-anim {
    pointer-events: none;
    z-index: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    & > canvas {
      transform: scale(0.5);
      opacity: 0;
      transition: opacity 0.7s ease;
    }
    &.loaded {
      & > canvas {
        opacity: 1;
      }
    }

    .tablet & {
      & > canvas {
        transform: scale(0.35);
      }
    }

    .mobile & {
      & > canvas {
        transform: scale(0.3);
      }
    }
  }

  &-title {
    z-index: 1;
    position: relative;
    @include header-h-2;

    .desktop & {
      @media only screen and (max-width: 1370px) {
        font-size: 1.7rem;
      }
    }

    .tablet & {
      @include title-m;
    }

    .mobile & {
      @include title-xs;
      line-height: normal;
    }
  }

  .tablet & {
    width: toRem(168);
    border-radius: 16px;

    .card-title {
      @include title-m;
    }
  }

  .mobile & {
    width: toRem(140) !important;
    border-radius: 8px;

    .card-title {
      @include title-xs;
    }
  }
}
</style>
